import React, { useRef } from 'react'
import Slider, { InnerSlider, Settings } from 'react-slick'
import { IMultipleSlideshowProps } from './types'
import SlideCard from '@/components/widgets/slide-card'
import Icon from '@/components/base/icon'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const MultipleSlideshow: React.FC<IMultipleSlideshowProps> = ({
  data = [],
  slidesToShow = 6,
}) => {
  const sliderRef = useRef<Slider>(null)

  const getStep = (): number => {
    if (typeof window === 'undefined') return 1

    const width = window.innerWidth
    if (width <= 550) return 1
    if (width <= 768) return 2
    if (width <= 1024) return 3
    if (width <= 1440) return 4

    return slidesToShow
  }

  type ExtendedInnerSlider = InnerSlider & {
    state: {
      currentSlide: number
    }
  }

  const PrevButton = () => {
    const innerSlider = sliderRef.current?.innerSlider as ExtendedInnerSlider
    const current = innerSlider?.state?.currentSlide ?? 0
    const step = getStep()
    return (
      <button
        className="slick-prev-arrow"
        onClick={() => sliderRef.current?.slickGoTo(current - step)}
      >
        <Icon name="arrow-left" size="large" />
      </button>
    )
  }

  const NextButton = () => {
    const innerSlider = sliderRef.current?.innerSlider as ExtendedInnerSlider
    const current = innerSlider?.state?.currentSlide ?? 0
    const step = getStep()
    return (
      <button
        className="slick-next-arrow"
        onClick={() => sliderRef.current?.slickGoTo(current + step)}
      >
        <Icon name="arrow-right" size="large" />
      </button>
    )
  }

  const settings: Settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow,
    slidesToScroll: slidesToShow,
    centerMode: true,
    centerPadding: '98px',
    swipeToSlide: true,
    nextArrow: <PrevButton />,
    prevArrow: <NextButton />,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToScroll: slidesToShow,
          slidesToShow: slidesToShow,
          centerPadding: '120px',
        },
      },
      {
        breakpoint: 1440,
        settings: {
          slidesToScroll: 4,
          slidesToShow: 4,
          centerPadding: '100px',
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToScroll: 3,
          slidesToShow: 3,
          centerPadding: '80px',
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToScroll: 2,
          slidesToShow: 2,
          centerPadding: '70px',
        },
      },
      {
        breakpoint: 550,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1,
          centerPadding: '52px',
        },
      },
    ],
  }

  return data.length > 0 ? (
    <div className="multiple-slideshow-container">
      <Slider ref={sliderRef} {...settings}>
        {data.map((card, index) => (
          <div className="item-layout" key={index}>
            <div className="item">
              <SlideCard
                image={card?.image}
                linkSrc={card?.anchor}
                title={card?.title}
                isHorizontal
                shadow="all"
                isSustainable={card?.isSustainable}
              />
            </div>
          </div>
        ))}
      </Slider>
    </div>
  ) : null
}

export default MultipleSlideshow
